window.addEventListener('load', (event) => {
  let tl = gsap.timeline({
    // yes, we can add it to an entire timeline!
    scrollTrigger: {
      trigger: '.sticky-slideshow-story .bg',
      endTrigger: '.sticky-slideshow-story',
      pin: true, // pin the trigger element while active
      start: 'top top', // when the top of the trigger hits the top of the viewport
      end: 'bottom bottom', // end after scrolling 500px beyond the start
      preventOverlaps: true,
    },
  });
});

// ScrollTrigger.create({
//   trigger: '.sticky-slideshow-story article:nth-child(1) .la-media img',
//   pin: true,
//   start: 'center center',
//   endTrigger: '.sticky-slideshow-story article:nth-child(2) .la-media img',
//   end: 'center center',
// });

// ScrollTrigger.create({
//   trigger: '.sticky-slideshow-story article:nth-child(2) .la-media img',
//   pin: true,
//   start: 'center center',
//   endTrigger: '.sticky-slideshow-story article:nth-child(3) .la-media img',
//   end: 'center center',
// });
